export default __webpack_public_path__ + "static/sge_02-26fb8cf594b513d13d7f30a87977da1a.png";